import type { EventType } from 'mitt';
import mitt from 'mitt';
import { isProd, isServer } from '~/utils/EnvUtils';
import type { ResultObj } from '~/types/GoogleSearch';
import { type QuizizzAIQuizGenModalOptions } from '~/components/CreateWithAI/types.d';
import type { IOptions as ISuperUpsellOptions } from '~/types/utils/Upsell';

// https://github.com/developit/mitt#typescript
export interface IEvents extends Record<EventType, unknown> {
  'quiz-modal-set/share-quiz': {
    quiz: any,
    source: string,
  },
  'superUpsell:show': {
    type: string,
    options?: ISuperUpsellOptions,
  },
  'ShareQuizModal/setQuizVisibililty': {
    quizId: string,
    visibility: boolean,
  },
  'userSet': {
    user: any,
  },

  'qfwPricingModal:show': {
    source: string,
    feat?: string,
  },
  'qfwGameSettings:setExpiry': string,

  'overlay:show': {
    zIndex: number,
  },
  'overlay:hide': undefined,
  'notification:show': undefined,
  'quizizzAiQuizGenModal:show': QuizizzAIQuizGenModalOptions,
  'googleImageSearch:searchInit': void,
  'youtubeSearch:searchInit': void,
  'googleImageSearch:searchStarted': {
    query: string,
  },
  'youtubeSearch:searchStarted': {
    query: string,
  },
  'googleImageSearch:resultsFetched': {
    results: ResultObj[],
    container: HTMLElement,
    query: string,
  },
  'youtubeSearch:noResults': void,
  'googleImageSearch:searchFailed': void,
  'youtubeSearch:searchFailed': void,
  'youtubeSearch:resultsFetched': {
    results: ResultObj[],
    container: HTMLElement,
    query: string,
  },
  'googleImageSearch:resultsRendered': {
    resultElements: HTMLElement[],
    pageNumber: number,
    query: string,
  },
  'youtubeSearch:resultsRendered': {
    resultElements: HTMLElement[],
    pageNumber: number,
    query: string,
  },
  'continueWithoutSuperQuestions': void,
  'mainHeaderSearchBar:change': string,
  'qfwGameSettings:error': {
    [key: string]: string,
  },
  'SharedFolder/createTeamV2': {
    source: string,
  },
  'subject-scroll-click': any,
  'authModal:show': {
    type: string,
    title: string,
    redirectTo?: {
      path: string,
      query: any,
    },
  },
  'superUpsellReferral:show': {
    type: string,
    options?: Record<string, any>,
  },
  'showQuizWarning:show': {
    message: string,
    icon: string,
    iconBg: string,
  },
  'startPostSaveProcedure': void,
  'trialCollaborationModal:show': void,
  'prefetchBtsRecommendations': void,
  'refetchBtsRecommendations': void,
  'importSlide:beginImport': boolean,
  'importSlide:importStarted': {
    totalSlides: number,
    isEditableImport: boolean,
  },
  'importSlide:allSlidesImported': {
    slides: any,
    pdfData: any,
    key: string,
    isEditableImport: boolean,
  },
  'importSlide:updateProgress': {
    progress: number,
  },
};

const emitter = mitt<IEvents>();

const eventBus = {
  $on: emitter.on,
  $off: emitter.off,
  $emit: emitter.emit,
  $clearAll: emitter.all.clear,
};

if (!isProd() && !isServer()) {
  window.__eventBus = eventBus;
}

export default eventBus;
